import request from '@/utils/request'

export function TypeList() {
    return request({
        url: '/product/type',
        method: 'get'
    })
}


export function ModelList(params) {
    return request({
        url: '/product/model',
        method: 'get',
        params: params
    })
}

export function List(params) {
    return request({
        url: `/product/list`,
        method: 'get',
        params: params
    })
}

export function Order(data) {
    return request({
        url: `/order`,
        method: 'post',
        data
    })
}